import React, { useState } from "react";
import Spline from "@splinetool/react-spline";

const SplineObject = () => {
  const [isLoading, setIsLoading] = useState(true);

  function handleLoad() {
    setIsLoading(false);
  }

  return (
    <div className="spline-container">
      {isLoading && (
        <div className="spline-loader">
          <div className="spinner"></div>
          <p>Loading 3D Scene...</p>
        </div>
      )}
      <Spline
        scene="https://prod.spline.design/V-An0vQrLMXA41uw/scene.splinecode"
        onLoad={handleLoad}
        style={{
          opacity: isLoading ? 0 : 1,
          transition: "opacity 0.5s ease-in-out",
        }}
      />
    </div>
  );
};

export default SplineObject;
